import React, { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { BsUpload, BsXLg } from 'react-icons/bs'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { FaFileExcel } from 'react-icons/fa6'
import SwalCustom from '../../alert/swal-custom'
import LabelCustom from '../label-custom'
import { fnDateEn } from '../../helper/fnDateEn'
import CustomDatePicker from '../custom/CustomDatePicker'
import { readSpreadsheetObjects } from '../../helper/spreadsheet/read-spreadsheet'

export default function ActionImportExcel({
  handleSubmit,
  isSave,
  index_row = 0
}) {
  const [seleteDate, setSeleteDate] = useState()

  const [dataTemplate, setDataTemplate] = useState([])
  const [filedocs, setFileDocs] = useState()

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 8000000,
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        '.xlsx'
      ],
      'text/csv': ['.csv']
    },
    onDrop: (acceptedFiles) => {
      readUploadFile(acceptedFiles[0])
    },
    onDropRejected: () => {
      SwalCustom({
        icon: 'error',
        title: 'You can only upload 1 file & maximum size of 8 MB.',
        showConfirmButton: false,
        timer: 2000
      })
    }
  })
  const htmlUploadFile = (
    <div
      {...getRootProps({ className: 'dropzone z-index-1 ' })}
      style={{
        cursor: 'pointer',
        border: '1px dashed #2b5dfe',
        borderRadius: '0.357rem',
        minHeight: '35px',
        width: '100%',
        justifyContent: 'center',
        display: 'flex'
      }}
    >
      <input {...getInputProps({ className: 'form-control z-index-1' })} />
      <span
        className="my-auto fw-light small"
        style={{ color: '#2b5dfe' }}
      >
        <BsUpload className="me-2" /> Choose File
      </span>
    </div>
  )

  const readUploadFile = async (file) => {
    if (!file) return

    try {
      const data = await readSpreadsheetObjects(file, {
        headerRowIndex: index_row ? 1 : 0
      })

      setDataTemplate(data)
      setFileDocs(file)
    } catch (error) {
      setDataTemplate([])
      setFileDocs()
      SwalCustom({
        icon: 'error',
        title: 'Unable to read this spreadsheet.',
        showConfirmButton: false,
        timer: 2000
      })
    }
  }
  const fileList = filedocs && (
    <>
      <Card.Body
        key={filedocs.name}
        className="d-flex justify-content-between align-items-start shadow-sm border rounded-3 mt-3 p-3"
      >
        <div className="d-flex ">
          <span>
            {' '}
            <FaFileExcel
              className="opacity-25"
              style={{
                fontSize: '2.8rem'
              }}
            />
          </span>
          <div className="my-auto ms-3">
            <p className="mb-0 ">{filedocs.name}</p>
            <label className="font-small-2 fw-light ">
              {' '}
              {Math.round(filedocs.size / 100) / 10 > 1000
                ? `${(Math.round(filedocs.size / 100) / 10000).toFixed(1)} mb`
                : `${(Math.round(filedocs.size / 100) / 10).toFixed(1)} kb`}
            </label>
          </div>
        </div>
        <div onClick={() => handleRemoveFile()}>
          <span>
            <BsXLg fontSize={20} />
          </span>
        </div>
      </Card.Body>

      <p className="mt-3 text-end">ทั้งหมด {dataTemplate.length} รายการ </p>
      <p className="text-end">
        <label className="fs-3">
          ยอดรวม{' '}
          {dataTemplate.reduce((a, b) => a + b.Amount, 0).toLocaleString()} บาท
        </label>
      </p>
    </>
  )
  const handleRemoveFile = () => {
    setDataTemplate([])
    setFileDocs()
  }

  const fnSave = () => {
    let body = dataTemplate.map((d) => ({
      ...d,
      date: fnDateEn(seleteDate).format('YYYY-MM-DD')
    }))

    handleSubmit(body)
  }

  return (
    <div className="mt-3">
      <Row className="g-3">
        <Col xl={12}>
          <LabelCustom text={'Periods'} />
          <CustomDatePicker
            showYearDropdown
            showMonthYearPicker
            dateFormat="MM/yyyy"
            value={seleteDate}
            onChange={(date) => {
              setSeleteDate(date)
            }}
          />
        </Col>
        <Col xl={12}>
          <LabelCustom text={'   Attach File'} subtext={'(Excel,csv)'} />

          {htmlUploadFile}
        </Col>
      </Row>
      <Row>
        <Col xl={12}>{filedocs && fileList}</Col>
      </Row>

      <Row className="mt-5">
        <Col xl={12} className="d-flex justify-content-center gap-3">
          <Button
            size="sm"
            className="px-4"
            variant="light"
            onClick={handleRemoveFile}
          >
            Clear
          </Button>
          <Button
            size="sm"
            disabled={isSave || !filedocs}
            className="px-4"
            onClick={fnSave}
          >
            Submit{isSave && 'ting...'}
          </Button>
        </Col>
      </Row>
    </div>
  )
}
